import { Editor, Element as SlateElement, Transforms } from 'slate';
import { ReactEditor } from 'slate-react';

export const isMarkActive = (editor: ReactEditor, format: any) => {
  const marks = Editor.marks(editor);
  // @ts-ignore
  return marks ? marks[format] === true : false;
};

export const toggleMark = (editor: ReactEditor, format: any) => {
  const isActive = isMarkActive(editor, format);

  if (isActive) {
    Editor.removeMark(editor, format);
  } else {
    Editor.addMark(editor, format, true);
  }
};

export const isBlockActive = (editor: ReactEditor, format: any) => {
  // @ts-ignore
  const [match] = Editor.nodes(editor, {
    // @ts-ignore
    match: n => !Editor.isEditor(n) && SlateElement.isElement(n) && n.type === format,
  });

  return !!match;
};

const list_types = ['orderedList', 'unorderedList'];

export const toggleBlock = (editor: ReactEditor, format: any) => {
  const isActive = isBlockActive(editor, format);
  const isList = list_types.includes(format);

  Transforms.unwrapNodes(editor, {
    // @ts-ignore
    match: n => list_types.includes(!Editor.isEditor(n) && SlateElement.isElement(n) && n.type),
    split: true,
  });

  Transforms.setNodes(editor, {
    // @ts-ignore
    type: isActive ? 'paragraph' : isList ? 'list-item' : format,
  });

  if (isList && !isActive) {
    Transforms.wrapNodes(editor, {
      // @ts-ignore
      type: format,
      children: [],
    });
  }
};
